// const baseURL = 'http://localhost:8080/';
const baseURL = 'https://dulcemundo.komerzy.com/';
export default baseURL;
